import React, { useContext, useEffect, useRef } from 'react';
import './index.less';
import anime from 'animejs';
import { LoginModalCtx } from '..';
import bg from './bg.svg';
import { ArrowRight } from '@icon-park/react';

export function BlueStart() {
    const wrapRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        wrapRef.current.querySelectorAll('.title,.desc').forEach((el) => {
            el.innerHTML = el.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
        });

        anime({
            targets: ['.home .blue-start'],
            opacity: [0, 1],
            duration: 1000,
        });

        anime
            .timeline()
            .add({
                targets: ['.blue-start .title .letter'],
                translateY: ['1.1em', 0],
                opacity: [0, 1],
                duration: 600,
                easing: 'easeOutExpo',
                delay: (el, i) => 300 + 50 * i,
            })
            .add(
                {
                    targets: ['.blue-start .desc .letter '],
                    translateY: ['1.1em', 0],
                    opacity: [0, 1],
                    duration: 600,
                    easing: 'easeOutExpo',
                    delay: (el, i) => 30 * i,
                },
                '-=1100'
            )
            .add(
                {
                    targets: ['.blue-start .start-btn'],
                    translateY: ['1.1em', 0],
                    opacity: [0, 1],
                    translateZ: 0,
                    easing: 'easeOutExpo',
                    duration: 950,
                },
                '-=800'
            );
    }, []);
    const { enterSystem } = useContext(LoginModalCtx);
    return (
        <div className="blue-start" style={{ opacity: 0 }}>
            <img src={bg} className="bg-square" />
            <div className="main" ref={wrapRef}>
                <div className="title">全新起航，即刻出发。</div>
                <div className="desc">
                    快手DMP全面升级“磁力万象”品牌，功能更全面，效率更快人一步。
                </div>
                <span
                    className="start-btn button--sacnite button--round-s button--inverted"
                    onClick={enterSystem}
                >
                    <ArrowRight
                        className="arrow-right"
                        theme="filled"
                        size="32"
                        strokeWidth={3}
                        fill="#ffffff"
                    />
                    <span className="text">立即体验</span>
                </span>
            </div>
        </div>
    );
}

export default React.memo(BlueStart);
